import React, { useState, useCallback } from 'react'
import Draggable from 'react-draggable';
import { IconButton, Menu, MenuItem, Fade, ListItemIcon, useTheme } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TitleIcon from "@mui/icons-material/Title";
import {
    Videocam,
    VideocamOff,
    VolumeUp,
    VolumeOff,
    Settings,
    Logout,
} from "@mui/icons-material";
import GroupsIcon from "@mui/icons-material/Groups";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import AddReactionIcon from '@mui/icons-material/AddReaction';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import useApp from "../../store/contexts/AppContext";
import IconPhotoGallery from "../../components/Toolbox/IconPhotoGallery";
import UploadImage from "../../components/Toolbox/UploadImage";
import CircularProgress from "@mui/material/CircularProgress";
import SketchOnTeam from "../../components/Toolbox/SketchOnTeam"
import PersonalCanvas from "../../components/Toolbox/PersonalCanvas"
import capitalizeEachFirstWord from "../../utils/CapLetters";

const DraggableToolbox = ({
    clearCanvas,
    saveCanvasDrawing,
    saveScreenshot,
    toolboxMode,
    lineColor,
    colorPickerRef,
    setLineColor,
    lineThickness,
    setLineThickness,
    opacitySliderRef,
    lineOpacity,
    setLineOpacity,
    classes,
    isVideoOn,
    handleVideoToggle,
    isAudioOn,
    handleAudioToggle,
    showRoomParticipants,
    handleRoomParticipantsVisibility,
    handleReactionIconExpandClick,
    reactionIconExpanded,
    handleWebcamMenuClick,
    anchorWebcamMenuEl,
    handleWebcamMenuClose,
    openUserWebcamSettingsModal,
    handleRoomTitleToggle,
    showRoomTitle,
    handleRoomTeamsVisibility,
    showRoomTeams,
    loadANewPage,
    roomId,
    togglingRoomPath,
    isUserOnSpectatorMode,
    handleReactionIcon,
    classes2,
    textProps,
    setTextProps,
    addTextToCanvas,
    selectedTextCanvas,
    TextCanvas,
    setTextCanvas,
    removeSelectedText,
    toolboxRef,
    onImageSelect,
    activeTeamParticipantVideos,
    selectedTeam,
    changeSelectedTeam,
    handleStartDrawing,
    handleDraw,
    handleStopDrawing,
    teamCanvasVideoRef,
    teamTextCanvasRef,
    teamImageCanvasRef,
    teamDrawCanvasRef,
    teamEraseCanvasRef,
    doErasing,
    teamCompositeCanvasRef,
    selectedTeamTextCanvas,
    TeamTextCanvas,
    teamTextProps,
    setTeamTextCanvas,
    setTeamTextProps,
    handleToolboxModeChange,
    removeSelectedTeam,

    canvasVideoRef,
    hiddenCanvasStyle,
    textCanvasRef,
    imageCanvasRef,
    drawCanvasRef,
    eraseCanvasRef,
    compositeCanvasRef
}) => {
    const {
        toggleRoomToolbox,
        payForRoomScreenshotApiCall
    } = useApp();

    const theme = useTheme();

    const [isSendingScreenShot, setIsSendingScreenShot] = useState(false);
    const [isDragHandleHovered, setIsDragHandleHovered] = useState(false);
    const [isLoadingScreenshotPayment, setIsLoadingScreenshotPayment] = useState(false);
    const [hasOngoingPayment, setHasOngoingPayment] = useState(false);
    const [durationInSecs, setDurationInSecs] = useState("");

    const disallowedTeamCodesForSelection = ['team-spectator'];

    const closeToolboxPopup = () => {
        removeSelectedTeam();
        toggleRoomToolbox();
    };

    const toggleIsSendingScreenShot = () => {
        setIsSendingScreenShot(prev => !prev);
    };

    const payForRoomScreenshot = async () => {
        if (!durationInSecs) {
            return false;
        }

        setIsLoadingScreenshotPayment(true);
        setHasOngoingPayment(true);

        try {
            const makePayment = await payForRoomScreenshotApiCall(roomId, { duration_in_secs: durationInSecs });
            if (makePayment.success) {
                toggleIsSendingScreenShot();
                saveScreenshot(true, durationInSecs);
            }
        } catch (error) {
            console.error("Error paying for room screenshot:", error);
        } finally {
            setIsLoadingScreenshotPayment(false);
            setHasOngoingPayment(false);
        }
    };

    const handleTextChange = (e) => {
        const newText = e.target.value;
        if (selectedTeam) {
            if (selectedTeamTextCanvas >= 0) {
                setTeamTextCanvas(prevTexts => prevTexts.map((text, index) =>
                    index === selectedTeamTextCanvas ? { ...text, text: newText } : text
                ));
            } else {
                setTeamTextProps(prev => ({ ...prev, text: newText }));
            }
        } else {
            if (selectedTextCanvas >= 0) {
                setTextCanvas(prevTexts => prevTexts.map((text, index) =>
                    index === selectedTextCanvas ? { ...text, text: newText } : text
                ));
            } else {
                setTextProps(prev => ({ ...prev, text: newText }));
            }
        }
    };

    const getTextValue = selectedTeam
        ? (selectedTeamTextCanvas >= 0 ? TeamTextCanvas[selectedTeamTextCanvas].text : teamTextProps.text)
        : (selectedTextCanvas >= 0 ? TextCanvas[selectedTextCanvas].text : textProps.text);

    return (
        <Draggable handle=".toolbox-drag-handle" cancel="input,select,button,textarea,label,[role='button'],[role='option']">
            <div style={{
                position: 'absolute',
                top: '40%',
                left: '40%',
                transform: 'translate(-50%, -50%)',
                background: '#333',
                padding: '0px',
                zIndex: '2000'
            }}>
                <div
                    className="toolbox-drag-handle"
                    onMouseEnter={() => setIsDragHandleHovered(true)}
                    onMouseLeave={() => setIsDragHandleHovered(false)}
                    style={{
                        padding: '6px 10px',
                        cursor: 'grab',
                        userSelect: 'none',
                        background: isDragHandleHovered ? '#555' : '#444',
                        borderBottom: '1px solid #222',
                        transition: 'background 0.15s',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <b style={{ color: '#ddd', fontSize: '13px', letterSpacing: '0.5px' }}>⠿ Toolbox</b>
                    <span
                        style={{
                            backgroundColor: "tomato",
                            textAlign: "center",
                            cursor: "pointer",
                            borderRadius: '3px',
                            lineHeight: 0,
                            padding: '2px',
                        }}
                        onClick={closeToolboxPopup}
                    >
                        <CloseIcon style={{ fontSize: '18px' }} />
                    </span>
                </div>
                <div style={{ padding: '10px', maxHeight: 500, overflowY: "scroll" }} ref={toolboxRef}>
                    <ButtonGroup size="small" variant="contained" aria-label="Basic button group">
                        <Button onClick={saveCanvasDrawing}>Save Drawing</Button>
                        <Button onClick={() => saveScreenshot(false)}>Save Screenshot</Button>
                        <Button onClick={toggleIsSendingScreenShot}
                            style={{
                                backgroundColor: isSendingScreenShot ? theme.palette.primary.dark : theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                            }}>Send</Button>
                        <Button onClick={clearCanvas}>Clear</Button>
                    </ButtonGroup>
                    <div style={{ marginTop: 15 }}>
                        <React.Fragment>
                            <FormControl fullWidth style={{ marginBottom: '20px', display: isSendingScreenShot ? 'none' : 'flex' }}>
                                <InputLabel variant="standard" htmlFor="uncontrolled-native" style={{ color: 'white' }}>
                                    Choose Mode
                                </InputLabel>
                                <NativeSelect
                                    defaultValue={toolboxMode}
                                    inputProps={{
                                        name: 'Mode',
                                        id: 'mode-uncontrolled-native',
                                    }}
                                    label="Mode"
                                    onChange={(e) => handleToolboxModeChange(e.target.value)}
                                    sx={{
                                        backgroundColor: 'lightgray',
                                        padding: '5px 10px',
                                        '& .MuiMenu-paper': {
                                            zIndex: '3001',
                                        },
                                    }}
                                >
                                    <option value="view">View</option>
                                    <option value="draw">Draw</option>
                                    <option value="erase">Erase</option>
                                    <option value="text">Text</option>
                                    <option value="imageAndIcons">Images & Icons</option>
                                </NativeSelect>
                            </FormControl>

                            {toolboxMode !== "view" && (
                                <FormControl fullWidth style={{ marginBottom: '20px', display: isSendingScreenShot ? 'none' : 'flex' }}>
                                    <InputLabel variant="standard" htmlFor="uncontrolled-native" style={{ color: 'white' }}>
                                        Choose Team <small style={{ color: 'tomato' }}>This team will be sent whatever is drawn on the screen below</small>
                                    </InputLabel>
                                    <NativeSelect
                                        defaultValue={"empty"}
                                        inputProps={{
                                            name: 'Mode',
                                            id: 'mode-uncontrolled-native',
                                        }}
                                        label="Team viewer"
                                        sx={{
                                            backgroundColor: 'lightgray',
                                            padding: '5px 10px',
                                            '& .MuiMenu-paper': {
                                                zIndex: '3001',
                                            },
                                        }}
                                        onChange={changeSelectedTeam}
                                    >
                                        <option value="empty">Select a team</option>
                                        {activeTeamParticipantVideos.length > 0 ? (
                                            activeTeamParticipantVideos.map((participant) =>
                                                !disallowedTeamCodesForSelection.includes(participant.userTeamCode) && (
                                                    <option key={participant.userTeamCode} value={participant.userTeamCode}>
                                                        {capitalizeEachFirstWord(participant.userTeamName)}
                                                    </option>
                                                )
                                            )
                                        ) : (
                                            <option value="empty">No team members available at the moment</option>
                                        )}
                                    </NativeSelect>
                                </FormControl>
                            )}

                            <div style={{ margin: '0px auto 20px', zIndex: '2001', display: selectedTeam && 'none' }} onMouseDown={(e) => e.stopPropagation()}>
                                <PersonalCanvas
                                    canvasVideoRef={canvasVideoRef}
                                    hiddenCanvasStyle={hiddenCanvasStyle}
                                    toolboxMode={toolboxMode}
                                    textCanvasRef={textCanvasRef}
                                    imageCanvasRef={imageCanvasRef}
                                    drawCanvasRef={drawCanvasRef}
                                    eraseCanvasRef={eraseCanvasRef}
                                    compositeCanvasRef={compositeCanvasRef}
                                    handleStartDrawing={handleStartDrawing}
                                    handleDraw={handleDraw}
                                    handleStopDrawing={handleStopDrawing}
                                    doErasing={doErasing}
                                    isSendingScreenShot={isSendingScreenShot}
                                />
                            </div>

                            {selectedTeam && selectedTeam?.screenshot && (
                                <SketchOnTeam
                                    selectedTeam={selectedTeam}
                                    toolboxMode={toolboxMode}
                                    handleStartDrawing={handleStartDrawing}
                                    handleDraw={handleDraw}
                                    handleStopDrawing={handleStopDrawing}
                                    teamCanvasVideoRef={teamCanvasVideoRef}
                                    teamTextCanvasRef={teamTextCanvasRef}
                                    teamImageCanvasRef={teamImageCanvasRef}
                                    teamDrawCanvasRef={teamDrawCanvasRef}
                                    teamEraseCanvasRef={teamEraseCanvasRef}
                                    doErasing={doErasing}
                                    teamCompositeCanvasRef={teamCompositeCanvasRef}
                                    isSendingScreenShot={isSendingScreenShot}
                                />
                            )}
                        </React.Fragment>
                    </div>

                    {(toolboxMode === "draw" || toolboxMode === "erase") && (
                        <div style={{ background: "#5F5D5D", padding: '10px 5px', display: isSendingScreenShot ? 'none' : 'block' }}>
                            {toolboxMode === "draw" && (
                                <>
                                    <div id="ColorEditor">
                                        <label htmlFor="color" style={{ paddingRight: '10px' }}><b>Color:</b></label>
                                        <input type="color" value={lineColor} ref={colorPickerRef}
                                            onChange={(e) => {
                                                const newColor = e.target.value;
                                                setLineColor(newColor);

                                                if (selectedTeam) {
                                                    if (selectedTeamTextCanvas >= 0) {
                                                        setTeamTextCanvas((prevTexts) => {
                                                            const newTexts = [...prevTexts];
                                                            newTexts[selectedTeamTextCanvas] = {
                                                                ...newTexts[selectedTeamTextCanvas],
                                                                color: newColor
                                                            };
                                                            return newTexts;
                                                        });
                                                    } else {
                                                        setTeamTextProps({ ...teamTextProps, color: newColor });
                                                    }
                                                } else {
                                                    if (selectedTextCanvas >= 0) {
                                                        setTextCanvas((prevTexts) => {
                                                            const newTexts = [...prevTexts];
                                                            newTexts[selectedTextCanvas] = {
                                                                ...newTexts[selectedTextCanvas],
                                                                color: newColor
                                                            };
                                                            return newTexts;
                                                        });
                                                    } else {
                                                        setTextProps({ ...textProps, color: newColor });
                                                    }
                                                }
                                            }}
                                            onMouseDown={(e) => e.stopPropagation()} />
                                    </div>
                                    <div id="OpacityEditor" style={{ marginTop: '10px' }}>
                                        <label><b>Opacity:</b></label>
                                        <span style={{ position: "relative", top: '3px' }}>
                                            <input ref={opacitySliderRef} type="range" min={1} max={100} value={lineOpacity} onChange={(e) => setLineOpacity(e.target.value)} onMouseDown={(e) => e.stopPropagation()} />
                                        </span>
                                    </div>
                                </>
                            )}
                            <div id="StrokeSizeEditor" style={{ marginTop: '10px' }}>
                                <label htmlFor="stroke-size"><b>Stroke size:</b></label>
                                <span style={{ position: "relative", top: '3px' }}>
                                    <input type="range" id="stroke-size" min={1} max={50} value={lineThickness} onChange={(e) => setLineThickness(e.target.value)} onMouseDown={(e) => e.stopPropagation()} />
                                </span>
                            </div>
                        </div>
                    )}

                    {(toolboxMode === "text") && (
                        <div style={{ background: "#5F5D5D", padding: '10px 5px', display: isSendingScreenShot ? 'none' : 'block' }}>
                            <div style={{ marginBottom: "10px" }}>
                                <span style={{ position: "relative" }}>
                                    <TextField variant="standard" label="Enter text" autoFocus={true}
                                        maxLength={100}
                                        style={{ width: '100%', color: '#fff' }}
                                        value={getTextValue}
                                        autoComplete='off'
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onChange={handleTextChange}
                                        InputProps={{
                                            style: {
                                                color: '#fff',
                                            },
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                color: '#D8D8D8',
                                            },
                                        }} />
                                </span>
                            </div>

                            <div id="ColorEditor">
                                <label htmlFor="color" style={{ paddingRight: '10px' }}><b>Color:</b></label>
                                <input type="color" value={selectedTeam ? (selectedTeamTextCanvas >= 0 ? TeamTextCanvas[selectedTeamTextCanvas].color : teamTextProps.color) : (selectedTextCanvas >= 0 ? TextCanvas[selectedTextCanvas].color : textProps.color)} ref={colorPickerRef}
                                    onChange={(e) => {
                                        const newColor = e.target.value;
                                        setLineColor(newColor);

                                        if (selectedTeam) {
                                            if (selectedTeamTextCanvas >= 0) {
                                                setTeamTextCanvas((prevTexts) => {
                                                    const newTexts = [...prevTexts];
                                                    newTexts[selectedTeamTextCanvas] = {
                                                        ...newTexts[selectedTeamTextCanvas],
                                                        color: newColor
                                                    };
                                                    return newTexts;
                                                });
                                            } else {
                                                setTeamTextProps({ ...teamTextProps, color: newColor });
                                            }
                                        } else {
                                            if (selectedTextCanvas >= 0) {
                                                setTextCanvas((prevTexts) => {
                                                    const newTexts = [...prevTexts];
                                                    newTexts[selectedTextCanvas] = {
                                                        ...newTexts[selectedTextCanvas],
                                                        color: newColor
                                                    };
                                                    return newTexts;
                                                });
                                            } else {
                                                setTextProps({ ...textProps, color: newColor });
                                            }
                                        }
                                    }}
                                    onMouseDown={(e) => e.stopPropagation()} />
                            </div>

                            <div id="FontSizeEditor" style={{ marginTop: '10px' }}>
                                <label htmlFor="fontSize" style={{ paddingRight: '10px' }}><b>Font Size:</b></label>
                                <span>
                                    <input
                                        type="number"
                                        id="fontSize"
                                        min={8}
                                        max={64}
                                        value={selectedTeam
                                            ? (selectedTeamTextCanvas >= 0 ? TeamTextCanvas[selectedTeamTextCanvas].fontSize : teamTextProps.fontSize)
                                            : (selectedTextCanvas >= 0 ? TextCanvas[selectedTextCanvas].fontSize : textProps.fontSize)
                                        }
                                        onChange={(e) => {
                                            const newFontSize = parseInt(e.target.value);
                                            if (selectedTeam) {
                                                if (selectedTeamTextCanvas >= 0) {
                                                    setTeamTextCanvas((prevTexts) => {
                                                        const newTexts = [...prevTexts];
                                                        newTexts[selectedTeamTextCanvas] = {
                                                            ...newTexts[selectedTeamTextCanvas],
                                                            fontSize: newFontSize
                                                        };
                                                        return newTexts;
                                                    });
                                                } else {
                                                    setTeamTextProps({ ...teamTextProps, fontSize: newFontSize });
                                                }
                                            } else {
                                                if (selectedTextCanvas >= 0) {
                                                    setTextCanvas((prevTexts) => {
                                                        const newTexts = [...prevTexts];
                                                        newTexts[selectedTextCanvas] = {
                                                            ...newTexts[selectedTextCanvas],
                                                            fontSize: newFontSize
                                                        };
                                                        return newTexts;
                                                    });
                                                } else {
                                                    setTextProps({ ...textProps, fontSize: newFontSize });
                                                }
                                            }
                                        }}
                                    />
                                </span>
                            </div>

                            <div id="FontFamilyEditor" style={{ marginTop: '10px' }}>
                                <label htmlFor="fontFamily" style={{ paddingRight: '10px' }}><b>Font Family:</b></label>
                                <select
                                    id="fontFamily"
                                    value={selectedTeam
                                        ? (selectedTeamTextCanvas >= 0 ? TeamTextCanvas[selectedTeamTextCanvas].fontFamily : teamTextProps.fontFamily)
                                        : (selectedTextCanvas >= 0 ? TextCanvas[selectedTextCanvas].fontFamily : textProps.fontFamily)
                                    }
                                    onChange={(e) => {
                                        if (selectedTeam) {
                                            if (selectedTeamTextCanvas >= 0) {
                                                setTeamTextCanvas((prevTexts) => {
                                                    const newTexts = [...prevTexts];
                                                    newTexts[selectedTeamTextCanvas] = {
                                                        ...newTexts[selectedTeamTextCanvas],
                                                        fontFamily: e.target.value
                                                    };
                                                    return newTexts;
                                                });
                                            } else {
                                                setTeamTextProps({ ...teamTextProps, fontFamily: e.target.value });
                                            }
                                        } else {
                                            if (selectedTextCanvas >= 0) {
                                                setTextCanvas((prevTexts) => {
                                                    const newTexts = [...prevTexts];
                                                    newTexts[selectedTextCanvas] = {
                                                        ...newTexts[selectedTextCanvas],
                                                        fontFamily: e.target.value
                                                    };
                                                    return newTexts;
                                                });
                                            } else {
                                                setTextProps({ ...textProps, fontFamily: e.target.value });
                                            }
                                        }
                                    }}
                                >
                                    <option value="Arial">Arial</option>
                                    <option value="Verdana">Verdana</option>
                                    <option value="Times New Roman">Times New Roman</option>
                                    <option value="Helvetica">Helvetica</option>
                                    <option value="Georgia">Georgia</option>
                                    <option value="Courier New">Courier New</option>
                                    <option value="Trebuchet MS">Trebuchet MS</option>
                                    <option value="Impact">Impact</option>
                                    <option value="Comic Sans MS">Comic Sans MS</option>
                                    <option value="Tahoma">Tahoma</option>
                                    <option value="Lucida Sans Unicode">Lucida Sans Unicode</option>
                                    <option value="Palatino Linotype">Palatino Linotype</option>
                                    <option value="Garamond">Garamond</option>
                                    <option value="Bookman">Bookman</option>
                                    <option value="Brush Script MT">Brush Script MT</option>
                                    <option value="Copperplate">Copperplate</option>
                                    <option value="Papyrus">Papyrus</option>
                                </select>
                            </div>

                            <div style={{ marginTop: '10px' }}>
                                <label htmlFor="fontStyleEditor" style={{ paddingRight: '10px' }}><b>Font Style:</b></label>
                                <select
                                    id="fontStyle"
                                    value={selectedTeam
                                        ? (selectedTeamTextCanvas >= 0 ? TeamTextCanvas[selectedTeamTextCanvas].fontStyle : teamTextProps.fontStyle)
                                        : (selectedTextCanvas >= 0 ? TextCanvas[selectedTextCanvas].fontStyle : textProps.fontStyle)
                                    }
                                    onChange={(e) => {
                                        if (selectedTeam) {
                                            if (selectedTeamTextCanvas >= 0) {
                                                setTeamTextCanvas((prevTexts) => {
                                                    const newTexts = [...prevTexts];
                                                    newTexts[selectedTeamTextCanvas] = {
                                                        ...newTexts[selectedTeamTextCanvas],
                                                        fontStyle: e.target.value
                                                    };
                                                    return newTexts;
                                                });
                                            } else {
                                                setTeamTextProps({ ...teamTextProps, fontStyle: e.target.value });
                                            }
                                        } else {
                                            if (selectedTextCanvas >= 0) {
                                                setTextCanvas((prevTexts) => {
                                                    const newTexts = [...prevTexts];
                                                    newTexts[selectedTextCanvas] = {
                                                        ...newTexts[selectedTextCanvas],
                                                        fontStyle: e.target.value
                                                    };
                                                    return newTexts;
                                                });
                                            } else {
                                                setTextProps({ ...textProps, fontStyle: e.target.value });
                                            }
                                        }
                                    }}
                                >
                                    <option value="normal">Normal</option>
                                    <option value="italic">Italic</option>
                                    <option value="bold">Bold</option>
                                    <option value="bold italic">Bold Italic</option>
                                </select>
                            </div>

                            <div id="angleEditor" style={{ marginTop: '10px' }}>
                                <label><b>Angle:</b></label>
                                <span style={{ position: "relative", top: '3px' }}>
                                    <input
                                        type="range"
                                        min={-180}
                                        max={180}
                                        onMouseDown={(e) => e.stopPropagation()}
                                        value={selectedTeam
                                            ? (selectedTeamTextCanvas >= 0 ? TeamTextCanvas[selectedTeamTextCanvas].angle : teamTextProps.angle)
                                            : (selectedTextCanvas >= 0 ? TextCanvas[selectedTextCanvas].angle : textProps.angle)
                                        }
                                        onChange={(e) => {
                                            const newAngle = parseInt(e.target.value);
                                            if (selectedTeam) {
                                                if (selectedTeamTextCanvas >= 0) {
                                                    setTeamTextCanvas((prevTexts) => {
                                                        const newTexts = [...prevTexts];
                                                        newTexts[selectedTeamTextCanvas] = {
                                                            ...newTexts[selectedTeamTextCanvas],
                                                            angle: newAngle
                                                        };
                                                        return newTexts;
                                                    });
                                                } else {
                                                    setTeamTextProps({ ...teamTextProps, angle: newAngle });
                                                }
                                            } else {
                                                if (selectedTextCanvas >= 0) {
                                                    setTextCanvas((prevTexts) => {
                                                        const newTexts = [...prevTexts];
                                                        newTexts[selectedTextCanvas] = {
                                                            ...newTexts[selectedTextCanvas],
                                                            angle: newAngle
                                                        };
                                                        return newTexts;
                                                    });
                                                } else {
                                                    setTextProps({ ...textProps, angle: newAngle });
                                                }
                                            }
                                        }}
                                    />
                                </span>
                            </div>

                            <div style={{ marginTop: '10px' }}>
                                {selectedTeam ? (
                                    selectedTeamTextCanvas >= 0 ? (
                                        <Button
                                            style={{ width: '100%' }}
                                            size="small"
                                            onClick={() => removeSelectedText(true)}
                                            variant="contained"
                                        >
                                            Remove Text
                                        </Button>
                                    ) : (
                                        <Button
                                            style={{ width: '100%' }}
                                            size="small"
                                            onClick={() => addTextToCanvas(true)}
                                            variant="contained"
                                        >
                                            Add Text
                                        </Button>
                                    )
                                ) : (
                                    selectedTextCanvas >= 0 ? (
                                        <Button
                                            style={{ width: '100%' }}
                                            size="small"
                                            onClick={() => removeSelectedText(false)}
                                            variant="contained"
                                        >
                                            Remove Text
                                        </Button>
                                    ) : (
                                        <Button
                                            style={{ width: '100%' }}
                                            size="small"
                                            onClick={() => addTextToCanvas(false)}
                                            variant="contained"
                                        >
                                            Add Text
                                        </Button>
                                    )
                                )}
                            </div>
                        </div>
                    )}

                    {(toolboxMode === "view") && (
                        <div style={{ marginTop: 10, zIndex: '2001', display: isSendingScreenShot && 'none' }} className={reactionIconExpanded ? classes.videoOptionsContainer2 : classes.videoOptionsContainer}>
                            {reactionIconExpanded && (
                                <div className={classes.reactionOptions}>
                                    <IconButton aria-label="Like" onClick={() => handleReactionIcon('👍')}>
                                        <ThumbUpIcon className={classes2.customIconButton} />
                                    </IconButton>
                                    <IconButton aria-label="Dislike" onClick={() => handleReactionIcon('👎')}>
                                        <ThumbDownIcon className={classes2.customIconButton} />
                                    </IconButton>
                                    <IconButton aria-label="Love" onClick={() => handleReactionIcon('❤️')}>
                                        <FavoriteIcon className={classes2.customIconButton} />
                                    </IconButton>
                                    <IconButton aria-label="Sad" onClick={() => handleReactionIcon('💔')}>
                                        <SentimentVeryDissatisfiedIcon className={classes2.customIconButton} />
                                    </IconButton>
                                </div>
                            )}
                            <div className={classes.webcamOptions}>
                                {!isUserOnSpectatorMode ? (
                                    <React.Fragment>
                                        <Tooltip title={isVideoOn ? "Mute Video" : "Unmute Video"}>
                                            <IconButton
                                                color="inherit"
                                                aria-label={isVideoOn ? "Mute Video" : "Unmute Video"}
                                                onClick={handleVideoToggle}
                                                sx={{
                                                    bgcolor: isVideoOn ? "#8A8A8A" : "#D44401",
                                                    "&:hover": {
                                                        bgcolor: isVideoOn ? "#8A8A8A" : "#900C3F",
                                                    },
                                                }}
                                            >
                                                {isVideoOn ?
                                                    <Videocam sx={{
                                                        fontSize: '15px'
                                                    }} /> :
                                                    <VideocamOff sx={{
                                                        fontSize: '15px'
                                                    }} />}
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title={isAudioOn ? "Mute Audio" : "Unmute Audio"}>
                                            <IconButton
                                                color="inherit"
                                                aria-label={isAudioOn ? "Mute Audio" : "Unmute Audio"}
                                                onClick={handleAudioToggle}
                                                sx={{
                                                    bgcolor: isAudioOn ? "#8A8A8A" : "#D44401",
                                                    "&:hover": {
                                                        bgcolor: isAudioOn ? "#8A8A8A" : "#900C3F",
                                                    },
                                                }}
                                            >
                                                {isAudioOn ?
                                                    <VolumeUp sx={{
                                                        fontSize: '15px'
                                                    }} /> :
                                                    <VolumeOff sx={{
                                                        fontSize: '15px'
                                                    }} />}
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip
                                            title={
                                                showRoomParticipants ? "Hide Participants" : "Show Participants"
                                            }
                                        >
                                            <IconButton
                                                aria-label="participants"
                                                aria-controls="participantsOptions"
                                                aria-haspopup="true"
                                                onClick={handleRoomParticipantsVisibility}
                                                sx={{
                                                    bgcolor: showRoomParticipants ? "#8A8A8A" : "#D44401",
                                                    "&:hover": {
                                                        bgcolor: showRoomParticipants ? "#8A8A8A" : "#900C3F",
                                                    },
                                                }}
                                            >
                                                <GroupsIcon style={{ color: "white" }} sx={{
                                                    fontSize: '15px'
                                                }} />
                                            </IconButton>
                                        </Tooltip>
                                    </React.Fragment>
                                ) : null}

                                <Tooltip title="Emoji reactions">
                                    <IconButton
                                        aria-label="emoji reactions"
                                        onClick={handleReactionIconExpandClick}
                                        sx={{
                                            bgcolor: reactionIconExpanded ? "#D44401" : "#8A8A8A",
                                            "&:hover": {
                                                bgcolor: reactionIconExpanded ? "#900C3F" : "#8A8A8A",
                                            },
                                        }}
                                    >
                                        <AddReactionIcon style={{ color: "white" }} sx={{
                                            fontSize: '15px'
                                        }} />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="More Options">
                                    <IconButton
                                        aria-label="more options"
                                        aria-controls="webcamMenuOptions"
                                        aria-haspopup="true"
                                        onClick={handleWebcamMenuClick}
                                    >
                                        <MoreVertIcon style={{ color: "white" }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                            <Menu
                                id="webcamMenuOptions"
                                anchorEl={anchorWebcamMenuEl}
                                keepMounted
                                open={Boolean(anchorWebcamMenuEl)}
                                onClose={handleWebcamMenuClose}
                                TransitionComponent={Fade}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                        overflow: "visible",
                                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                        mt: 1.5,
                                        "& .MuiAvatar-root": {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                        },
                                        "&:before": {
                                            content: '""',
                                            display: "block",
                                            position: "absolute",
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: "background.paper",
                                            transform: "translateY(-50%) rotate(45deg)",
                                            zIndex: 0,
                                        },
                                    },
                                }}
                                transformOrigin={{ horizontal: "right", vertical: "top" }}
                                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                            >
                                <MenuItem onClick={openUserWebcamSettingsModal}>
                                    <ListItemIcon>
                                        <Settings fontSize="small" />
                                    </ListItemIcon>
                                    Settings
                                </MenuItem>
                                <MenuItem onClick={handleRoomTitleToggle}>
                                    <ListItemIcon>
                                        <TitleIcon fontSize="small" />
                                    </ListItemIcon>
                                    {showRoomTitle ? "Hide Room Title" : "Show Room Title"}
                                </MenuItem>
                                <MenuItem onClick={handleRoomTeamsVisibility}>
                                    <ListItemIcon>
                                        <Diversity1Icon fontSize="small" />
                                    </ListItemIcon>
                                    {showRoomTeams ? "Hide Room Teams" : "Show Room Teams"}
                                </MenuItem>
                                <MenuItem
                                    onClick={() => loadANewPage(togglingRoomPath)}
                                >
                                    <ListItemIcon>
                                        <DisplaySettingsIcon fontSize="small" />
                                    </ListItemIcon>
                                    {isUserOnSpectatorMode
                                        ? "Join Regular Mode"
                                        : "Join Spectator Mode"}
                                </MenuItem>
                                <MenuItem>
                                    <ListItemIcon>
                                        <Logout fontSize="small" />
                                    </ListItemIcon>
                                    Extra
                                </MenuItem>
                            </Menu>
                        </div>
                    )}

                    {(toolboxMode === "imageAndIcons") && (
                        <div style={{ background: "#5F5D5D", padding: '10px 5px', display: isSendingScreenShot ? 'none' : 'block' }}>
                            <UploadImage onImageSelect={onImageSelect} />
                            <IconPhotoGallery onImageSelect={onImageSelect} />
                        </div>
                    )}

                    {(
                        <div style={{ background: "#5F5D5D", padding: '10px 5px', display: isSendingScreenShot ? 'block' : 'none' }} onMouseDown={(e) => e.stopPropagation()}>
                            <small style={{ color: 'tomato' }}>Note: This coin goes to the room's wallet balance</small>
                            <FormControl style={{ width: '100%' }}>
                                <InputLabel variant="standard" htmlFor="uncontrolled-native" style={{ color: 'white' }}>
                                    Choose Screenshot Duration
                                </InputLabel>
                                <NativeSelect
                                    defaultValue={durationInSecs}
                                    inputProps={{
                                        name: 'Mode',
                                        id: 'mode-uncontrolled-native',
                                    }}
                                    label="Mode"
                                    onChange={(e) => {
                                        setDurationInSecs(e.target.value)
                                    }}
                                    sx={{
                                        backgroundColor: 'lightgray',
                                        padding: '5px 10px',
                                        '& .MuiMenu-paper': {
                                            zIndex: '3001',
                                        },
                                    }}
                                >
                                    <option value="">Choose Duration</option>
                                    <option value="5">5 Seconds (1 coin)</option>
                                    <option value="10">10 Seconds (2 coins)</option>
                                    <option value="15">15 Seconds (3 coins)</option>
                                    <option value="20">20 Seconds (4 coins)</option>
                                    <option value="25">25 Seconds (5 coins)</option>
                                    <option value="30">30 Seconds (6 coins)</option>
                                    <option value="35">35 Seconds (7 coins)</option>
                                    <option value="40">40 Seconds (8 coins)</option>
                                    <option value="45">45 Seconds (9 coins)</option>
                                    <option value="50">50 Seconds (10 coins)</option>
                                    <option value="55">55 Seconds (11 coins)</option>
                                    <option value="60">60 Seconds (12 coins)</option>
                                </NativeSelect>
                            </FormControl>
                            <div style={{ marginTop: '10px' }}>
                                <Button
                                    style={{ width: '100%' }}
                                    size="small"
                                    onClick={payForRoomScreenshot}
                                    variant="contained"
                                    disabled={!durationInSecs || hasOngoingPayment}
                                    disableElevation
                                    sx={{
                                        '&.Mui-disabled': {
                                            backgroundColor: '#a6684b',
                                            color: 'whitesmoke',
                                        },
                                    }}
                                >
                                    Pay{isLoadingScreenshotPayment && "ing"}
                                    {isLoadingScreenshotPayment && (
                                        <CircularProgress size={20} style={{ marginLeft: '10px' }} />
                                    )}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Draggable >
    );
};

export default DraggableToolbox;